import { lazy, Suspense } from 'react'

const MetricDetailPage = lazy(async () => {
  const module = await import('@/features/metrics/MetricDetailPage')
  return { default: module.MetricDetailPage }
})

const MetricFormPage = lazy(async () => {
  const module = await import('@/features/metrics/MetricForm')
  return { default: module.MetricFormPage }
})

function MetricRouteFallback() {
  return <p role="status">正在加载页面…</p>
}

export function MetricDetailRoute() {
  return (
    <Suspense fallback={<MetricRouteFallback />}>
      <MetricDetailPage />
    </Suspense>
  )
}

export function MetricFormRoute() {
  return (
    <Suspense fallback={<MetricRouteFallback />}>
      <MetricFormPage />
    </Suspense>
  )
}
